import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import prowider from '../../assets/images/prowider.jfif';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    CircularProgress,
    Toolbar,
    Card,
    Paper
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import {
    getBookingStatusClass,
    ROLE_PROVIDER,
    ROLE_CUSTOMER,
    BOOKING_STATUS_INITIATED,
    BOOKING_STATUS_END,
    PAYMENT_PENDING,
    getBookingPaymentStatus,
    getBookingPaymentStatusClass,
    BOOKING_STATUS_CONFIRMED,
    convertTimestampToDate,
    getDay,
    tConvert,
    SERVER_URL
} from '../../utils/config/constants.js';
import {
    KeyboardArrowDown,
    FilterList,
    ArrowForward,
    Check,
    Close,
    DoneOutline,
    Person,
    LocationCity,
    LocationOn,
    Phone,
    Email
} from '@material-ui/icons';
import { Redirect, withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton.js';
import {
    BOOKING_VIEW_ALL,
    BOOKING_VIEW_INPROGRESS,
    BOOKING_VIEW_NEW,
    BOOKING_VIEW_COMPLETED
} from '../../utils/config/constants';
import CommentIcon from '@material-ui/icons/Comment';
import IconButton from '@material-ui/core/IconButton';
import { NotificationManager } from 'react-notifications';
import { getCookies } from '../../utils/getToken.js';
import Axios from 'axios';

const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
class PendingBookingList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 1,
            scrollClicked: false,
            detailRender: false,
            bookingSelected: '',
            showScroll: true,
            bookingData: [],
            actionLoader: false
        };
    }
    componentDidMount() {

        this.getData();
    }
    getData = () => {
        const authToken = getCookies()
        Axios({
            method: 'get',
            url: `${SERVER_URL}/booking/list-requests`,
            params: {
                type: 1, append: false
            },
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                this.setState({
                    bookingData: resJson.data.data.bookingList
                })
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
            }
        })
    };

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };
    handlePageChange = () => {
        this.setState(
            function (previousState) {
                return {
                    page: previousState.page + 1,
                    scrollClicked: true
                };
            },
            () => {
                this.setState({ scrollClicked: false });
                this.props.providerBookingListAction({
                    page: this.state.page,
                    type: 1,
                    append: true
                });
            }
        );
    };
    renderScrollIcon = () => {
        if (this.state.scrollClicked) {
            return <CircularProgress />;
        } else {
            return (
                <Button variant="fab" color="primary">
                    <KeyboardArrowDown onClick={this.handlePageChange} />
                </Button>
            );
        }
    };
    renderDetail = key => {
        this.setState({ detailRender: true, bookingSelected: key });
    };

    bookingAction = (type, token) => {
        /* this.setState({ actionLoader: true }); */
        // alert(type)
        if (type == 1) {
            this.props.acceptAvailableBookingAction(
                { booking_id: token},
                this.onActionDone
            );
        } else if (type == 2) {
            this.props.rejectBookingAction(
                { bookingToken: token },
                this.onActionDone
            );
        } else if (type == 3) {
            this.props.completeBookingAction(
                { bookingToken: token },
                this.onActionDone
            );
        }
    };
    onActionDone = (success, data) => {
        if (success) {
            this.setState({ actionLoader: false });
            NotificationManager.success(
                <FormattedMessage
                    id="actionCompleted"
                    defaultMessage="Action Completed"
                />,
                'Success'
            );
            this.getData();
        } else {
            this.setState({ actionLoader: false });
            NotificationManager.error(
                <FormattedMessage
                    id="someError"
                    defaultMessage="Some Error Occured"
                />,
                'Error'
            );
        }
    };

    renderInitiateActions = booking => {
        if (this.state.actionLoader) {
            return <CircularProgress />;
        } else {
            return (
                <React.Fragment>
                    <div className="col-md-12 col-sm-12 col-xs-12  p-0">
                        <IconButton
                            aria-label="Accept"
                            color="green"
                            onClick={() => this.bookingAction(1, booking.key)}
                        >
                            <Check />
                        </IconButton>
                    </div>
                    {/* <div className="col-md-12 col-sm-12 col-xs-12 p-0">
                        <IconButton
                            aria-label="Accept"
                            color="red"
                            onClick={() => this.bookingAction(2, booking.token)}
                        >
                            <Close />
                        </IconButton>
                    </div> */}
                </React.Fragment>
            );
        }
    };

    renderApproveAction = booking => {
        if (this.state.actionLoader) {
            return <CircularProgress />;
        } else {
            return (
                <div className="col-md-12 col-sm-12 col-xs-12 p-0">
                    <IconButton
                        aria-label="Approve"
                        color="green"
                        onClick={() => this.bookingAction(3, booking.token)}
                    >
                        <DoneOutline />
                    </IconButton>
                </div>
            );
        }
    };

    renderPaymentStatus = booking => {
        return (
            <div
                className={getBookingPaymentStatusClass(booking.payment_status)}
            >
                <FormattedMessage
                    id="paymentStatus"
                    defaultMessage="Payment Status"
                />
                : {getBookingPaymentStatus(booking.payment_status)}
            </div>
        );
    };

    render() {
        const { classes, userData, match } = this.props;
        const { formatMessage } = this.props.intl;
        const { page, bookingData } = this.state;

        if (this.state.detailRender) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingSelected}`,
                bookingId: this.state.bookingSelected
            });
        }

        return (
            <div className="tz-2-com tz-2-main">
                <h4 className="d-flex justify-align-between">
                    Initiated Services
                </h4>

                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {bookingData && bookingData.length > 0 ? (
                                <List
                                    className={classes.root + ' list-check-out'}
                                >
                                    {bookingData && bookingData.length > 0 && bookingData.map(booking => {
                                        return (
                                            <ListItem
                                                key={booking.key}
                                                className={
                                                    classes.paper +
                                                    ' home-list-pop list-spac list-check-out-inn list-book-provide'
                                                }
                                            >
                                                <div className="row">
                                                    <div className="col-md-3 dashboard-booklist-img col-xs-12 col-12">
                                                        <ListItemAvatar>
                                                            <ProgressiveImage
                                                                delay={2000}
                                                                src={
                                                                    booking
                                                                        .bookingImage
                                                                        .medium
                                                                }
                                                                placeholder="promo-image"
                                                            >
                                                                {(
                                                                    src,
                                                                    loading
                                                                ) =>
                                                                    loading ? (
                                                                        this.renderPromoImage()
                                                                    ) : (
                                                                            <img
                                                                                width="200px"
                                                                                height="200px"
                                                                                src={
                                                                            prowider
                                                                                }
                                                                                alt="promo image"
                                                                            />
                                                                        )
                                                                }
                                                            </ProgressiveImage>
                                                        </ListItemAvatar>
                                                    </div>
                                                    <div className="col-md-7 col-sm-7 col-xs-12 col-12">
                                                        <ListItemText
                                                            className=" home-list-pop-desc inn-list-pop-desc"
                                                            disableTypography={
                                                                true
                                                            }
                                                            primary={
                                                                <React.Fragment>
                                                                    <h3>
                                                                        {
                                                                            booking.token
                                                                        }{' '}
                                                                        (
                                                                        {convertTimestampToDate(
                                                                            booking.datetime
                                                                        )}{' '}
                                                                        |{' '}
                                                                        {getDay(
                                                                            booking.datetime
                                                                        )}{' '}
                                                                        {tConvert(
                                                                            new Date(
                                                                                booking.datetime
                                                                            )
                                                                        )}
                                                                        )
                                                                    </h3>
                                                                    <h5>
                                                                        {booking.services.length > 0 ?
                                                                            booking
                                                                                .services[0]
                                                                                .service : ""
                                                                        }
                                                                    </h5>
                                                                    {booking.statusId ==
                                                                        BOOKING_STATUS_INITIATED ||
                                                                        (booking.statusId ==
                                                                            BOOKING_STATUS_CONFIRMED && (
                                                                                <React.Fragment>
                                                                                    {' '}
                                                                                    <p>
                                                                                        <Person />
                                                                                        {
                                                                                            booking
                                                                                                .customerAddress
                                                                                                .name
                                                                                        }
                                                                                    </p>
                                                                                    <p>
                                                                                        <LocationOn />
                                                                                        {
                                                                                            booking
                                                                                                .customerAddress
                                                                                                .address_line1
                                                                                        }
                                                                                    </p>
                                                                                    <p>
                                                                                        <Phone />
                                                                                        {
                                                                                            booking
                                                                                                .customerAddress
                                                                                                .phone
                                                                                        }

                                                                                        ,{' '}
                                                                                        <Email />
                                                                                        {
                                                                                            booking
                                                                                                .customerAddress
                                                                                                .email
                                                                                        }
                                                                                    </p>
                                                                                </React.Fragment>
                                                                            ))}
                                                                </React.Fragment>
                                                            }
                                                            secondary={
                                                                <React.Fragment>
                                                                    {
                                                                        booking.provider
                                                                    }
                                                                    <br />
                                                                    {this.renderPaymentStatus(
                                                                        booking
                                                                    )}
                                                                    <br />
                                                                    <div
                                                                        className={getBookingStatusClass(
                                                                            booking.status
                                                                        )}
                                                                    >
                                                                        <FormattedMessage
                                                                            id="bookingStatus"
                                                                            defaultMessage="Booking Status"
                                                                        />
                                                                        :{' '}
                                                                        {
                                                                            booking.status
                                                                        }
                                                                    </div>
                                                                    <br />
                                                                    {moment(
                                                                        booking.datetime
                                                                    ).format(
                                                                        'MM-DD-YYYY'
                                                                    )}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-md-1 col-sm-1 col-xs-12 col-12 pr-0">
                                                        {/* <IconButton
                                                            color="primary"
                                                            aria-label="Detail"
                                                            onClick={() =>
                                                                this.renderDetail(
                                                                    booking.key
                                                                )
                                                            }
                                                        >
                                                            <ArrowForward />
                                                        </IconButton>
 */}
                                                        {booking.statusId ==
                                                            BOOKING_STATUS_INITIATED && (
                                                                <React.Fragment>
                                                                    {this.renderInitiateActions(
                                                                        booking
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                        {booking.statusId ==
                                                            BOOKING_STATUS_END &&
                                                            booking.payment_status ==
                                                            PAYMENT_PENDING && (
                                                                <React.Fragment>
                                                                    {/* {this.renderApproveAction(
                                                                booking
                                                            )} */}
                                                                </React.Fragment>
                                                            )}
                                                    </div>
                                                </div>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            ) : (
                                    <Paper>
                                        <p
                                            style={{
                                                color: '#000',
                                                padding: '10px'
                                            }}
                                        >
                                            <FormattedMessage
                                                id="noBookingFound"
                                                defaultMessage="No Bookings found"
                                            />
                                        </p>
                                    </Paper>
                                )}
                        </div>
                    </div>
                </div>
                {bookingData.length > 0 && (
                    <div className="text-center">
                        {this.state.showScroll && this.renderScrollIcon()}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ bookings }) => {
    return {
        bookingData: bookings.bookingData.bookingList,
        bookingLoader: bookings.bookingLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(withRouter(injectIntl(PendingBookingList)));



// WEBPACK FOOTER //
// ./src/components/Providers/PendingBookingList.js